export default __webpack_public_path__ + "static/media/interior4.35257f17.webp";